import StateInterface from "../state-interface";
import { requirement } from "./requirement";

export const my_requirements: StateInterface["my_requirements"] = {
	requirements: [],
	requirements_count: 0,
	loading: false,
	initial_load_done: false,
	trigger_new_search: false,
	filter_status: "",
	filter_sort_field: "created_at",
	filter_sort_order: "desc",
	filter_page_number: 1,
	status_counts: null,
	selected_requirement: requirement,
	selected_requirement_claims: [],
	selected_requirement_loading: false,
};
